var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_801)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "url(#paint0_linear_11_801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 25C15.8444 25 15.6111 25 15.4556 24.9198C15.3 24.8396 15.1444 24.7594 14.9889 24.5991L11.0222 20.4292C9.77778 19.066 9 17.2217 9 15.2972C9 13.3726 9.77778 11.5283 11.0222 10.1651C12.3444 8.88208 14.1333 8 16 8C17.8667 8 19.6556 8.80189 20.9778 10.0849C22.2222 11.4481 23 13.2925 23 15.217C23 17.1415 22.2222 18.9858 20.9778 20.3491L16.9333 24.5189C16.7778 24.6792 16.7 24.7594 16.4667 24.8396C16.3111 24.9198 16.1556 25 16 25Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 18.5849C17.847 18.5849 19.3444 17.0412 19.3444 15.1368C19.3444 13.2325 17.847 11.6887 16 11.6887C14.1529 11.6887 12.6555 13.2325 12.6555 15.1368C12.6555 17.0412 14.1529 18.5849 16 18.5849Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11_801",
    x1: 16,
    y1: -18.0259,
    x2: -20.0519,
    y2: 13.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E4AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504968,
    stopColor: "#10C5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9240DC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapActive);
export default __webpack_public_path__ + "static/media/mapActive.5213a8afb44eb1d27cb69246b7949075.svg";
export { ForwardRef as ReactComponent };